import { PreApproved } from '@/components/buying-with';
import { Hero } from '@/components/common';
import { Image } from '@/components/ui/image';
import { List } from '@/components/ui/lists';
import { ListItem } from '@/components/ui/listitem';

export const items = [
  {
    id: '1',
    title: 'Need of a Realtor',
    description:
      'While buying a home, buyers will need to navigate multiple steps and interact with several people including loan officers, appraisers, notaries, home inspectors etc. Being appreciated as a trusted realtor, Jen will be able to provide you access to her vast network of resources to find the best professionals. ',
  },
  {
    id: '2',
    title: 'See Listings',
    description:
      'Jen will be in regular contact with you to ensure the listings that meet your checklist of preferences hit your inbox, even if they are not even public yet.',
  },
  {
    id: '3',
    title: 'Debrief on Property Information',
    description:
      'As you compare your property options, Jen will make sure you have all the important details presented, including property details, neighborhood, zoning, utilities, and development plans for adjacent properties so you can make the most educated decision.',
  },
  {
    id: '4',
    title: 'View Properties',
    description:
      'In order to view the homes, Jen will be represent your best interests and guide you every step of the way in making informed decision ',
  },
  {
    id: '5',
    title: 'In Your Court',
    description:
      'Many real estate transactions include a labor-intensive negotiating process. This doesn’t intimidate Jen; she will represent you through negotiating processes, financing meetings, property inspections, and other legal proceedings to get you the best deal possible.',
  },
  {
    id: '6',
    title: 'Get the Best Deal',
    description:
      "Working with Jen on your next home purchase will save you time and add professional assurance to every step of the process for FREE. With the guarantee of a solid investment, the decision could also make you wealthier when it's time to sell!",
  },
];

export default function BuyingWithPage() {
  return (
    <div>
      <Hero title="Buying a Property?" />
      <div className="px-4 lg:px-8">
        <section className="grid lg:grid-cols-12 my-12">
          <div className="lg:col-span-7 lg:max-w-2xl">
            <div className="get-buy">
              <h2 className="text-2xl md:text-4xl font-extrabold mb-2">
                Getting Ready to Buy
              </h2>
              <p className="text-base md:text-lg">
                Your house is one of the biggest financial investments
                you&apos;ll ever make. With Jen’s help, it can also be your
                wisest.
              </p>
              <div className="relative h-64 w-full md:w-80 lg:h-192 block lg:hidden my-6 mx-auto">
                <Image src="/img/sec2img.png" layout="fill" alt="Buy image" />
              </div>
              <List type="square">
                {items.map((el) => (
                  <ListItem key={el.id}>
                    <h3 className="text-lg md:text-2xl font-bold text-black md:mb-2">
                      {el.title}
                    </h3>
                    <p className="text-sm md:text-base leading-6 text-gray-600">
                      {el.description}
                    </p>
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
          <div className="lg:col-span-5 hidden lg:block">
            <div className="relative h-80 md:h-192">
              <Image
                src="/img/sec2img.png"
                layout="fill"
                alt="Buy image"
                objectFit="cover"
              />
            </div>
          </div>
        </section>

        <section className="my-6 md:my-20">
          <PreApproved />
        </section>
      </div>
    </div>
  );
}
